

exports.__esModule = true;
exports.$metaBuilder = void 0;
var _angular = require("angular");
var _model = require("xo-tracking/dist/model");
var _squid = require("squid");
function buildMeta() {
  return {
    token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
    cartId: _squid.$util.param('cart_id'),
    calc: _model.$CalDataModel.getCalCorrId(),
    csci: _model.$CalDataModel.getUUID(),
    locale: {
      country: _squid.$locale && _squid.$locale.country,
      language: _squid.$locale && _squid.$locale.lang
    },
    state: "ui_" + (_angular.$rootScope.currentState || 'checkout_init'),
    app_name: 'xoonboardingnodeweb'
  };
}
_squid.$Api.registerMetaBuilder(buildMeta);
var $metaBuilder = exports.$metaBuilder = {
  build: buildMeta
};
angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;
_model.$CalDataModel;
_squid.$util;
_squid.$meta;
_squid.$Api;
_squid.$locale;
_squid.$config;


//////////////////
// WEBPACK FOOTER
// ./js/lib/metaBuilder.js
// module id = ./js/lib/metaBuilder.js
// module chunks = 0